
export class FeedbackAudio {

    private feedbackAudio;

    private defaultMinIntervalBetween: number;

    private intervalAnd = true; //?

    constructor(src: string, minInterval: number = 0) {

        this.feedbackAudio = new Audio;

        this.feedbackAudio.src = src;

        this.setIntervalBetween(minInterval);
    }

    private setIntervalBetween(interval: number) {
        this.defaultMinIntervalBetween = interval
    }

    private startCountInterval() {

        // Time interval! 
        if (this.intervalAnd) {
            // intervalo maior que 300ms
            if (this.defaultMinIntervalBetween > 300) {

                this.intervalAnd = false;
                setTimeout(() => {
                    this.intervalAnd = true;
                }, this.defaultMinIntervalBetween);
            }
        }
    }

    public personalInterval(conditional: any = false) {
        
    }

    public play() {
        if (this.intervalAnd) {
            this.feedbackAudio.play();
            this.startCountInterval();
        }
    }
}
